import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { BusinessDomain, BusinessDomainRoles } from '../common/models/business-domain.model';
import { BusinessDomainService } from '../business-domain/business-domain.service';
import { BusinessDomainOwnersComponent } from './business-domain-owners.component';

@Component({
    selector: 'app-business-domain-details',
    imports: [CommonModule, MatTableModule, MatCardModule, BusinessDomainOwnersComponent, MatDividerModule],
    templateUrl: './business-domain-details.component.html',
    styleUrl: './business-domain-details.component.scss',
})
export class BusinessDomainDetailsComponent {
    protected domainDetailsAsync$!: Observable<BusinessDomain>;

    public constructor(
        private route: ActivatedRoute,
        private readonly businessDomainService: BusinessDomainService,
    ) {}

    public ngOnInit(): void {
        const businessDomainId = this.route.snapshot.paramMap.get('id')!;
        this.domainDetailsAsync$ = this.businessDomainService.getBusinessDomainDetails(businessDomainId);
    }

    protected getRoleNames(roles: BusinessDomainRoles): (keyof BusinessDomainRoles)[] {
        return Object.keys(roles) as (keyof BusinessDomainRoles)[];
    }
}
